<button type="button" class="btn btn-primary" [ngClass]="{'w-100': block, 'btn-sm': block}" [disabled]="disabled" (click)="save($event)">
  <span *ngIf="!busySaving"><i class="fas fa-check"></i></span>
  <span *ngIf="busySaving"><i class="fas fa-sync fa-spin"></i></span>
  Opslaan</button>